import JSBI from 'jsbi'

import { SolidityType, ChainId } from '../constants'
import { validateSolidityTypeInstance } from '../utils'

/**
 * A currency is any fungible financial instrument on Ethereum, including Ether and all ERC20 tokens.
 *
 * The only instance of the base class `Currency` is Ether.
 */
export class Currency {
  public readonly decimals: number
  public readonly symbol?: string
  public readonly name?: string

  /**
   * The only instance of the base class `Currency`.
   */
  public static readonly ETHERCurrency: Currency = new Currency(18, 'ETH', 'Ether')
  public static readonly BNBCurrency: Currency = new Currency(18, 'BNB', 'Binance')
  public static readonly GSCurrency: Currency = new Currency(18, 'GC', 'GSChain')
  public static readonly OKTCurrency: Currency = new Currency(18, 'OKT', 'OKExChain')
  public static ETHER: Currency

  public static readonly ENATIVE: { [chainId in ChainId]: Currency } = {
    [ChainId.MAINNET]: Currency.ETHERCurrency,
    [ChainId.KOVAN]: Currency.ETHERCurrency,
    [ChainId.RINKEBY]: Currency.ETHERCurrency,
    [ChainId.ROPSTEN]: Currency.ETHERCurrency,
    [ChainId.GÖRLI]: Currency.ETHERCurrency,
    [ChainId.GSTESTNET]: Currency.GSCurrency,
    [ChainId.BSCMAINNET]: Currency.BNBCurrency,
    [ChainId.BSCTESTNET]: Currency.BNBCurrency,
    [ChainId.OKEX]: Currency.OKTCurrency,
    [ChainId.OKEX_TESTNET]: Currency.OKTCurrency
  }

  /**
   * Constructs an instance of the base class `Currency`. The only instance of the base class `Currency` is `Currency.ETHER`.
   * @param decimals decimals of the currency
   * @param symbol symbol of the currency
   * @param name of the currency
   */
  protected constructor(decimals: number, symbol?: string, name?: string) {
    validateSolidityTypeInstance(JSBI.BigInt(decimals), SolidityType.uint8)

    this.decimals = decimals
    this.symbol = symbol
    this.name = name
  }

  public static getCurrentChainIdCurrency(chainId?: any): Currency {
    const _chainId: ChainId = chainId || localStorage.getItem('chainId') || 1281
    return Currency.ENATIVE[_chainId]
  }
}
Currency.ETHER = Currency.getCurrentChainIdCurrency()

const ETHER = Currency.ETHER
export { ETHER }
